import _ from "lodash"
import PropTypes from "prop-types"

function TypeRadioOutcomes(props) {
  const matchingOption = _.find(props.options, { value: `${props.value}` })
  const displayValue = matchingOption ? matchingOption.label : props.value
  let newValue = ""
  if (!_.isEmpty(props.description)) {
    newValue =
      "<span class='outcomes-description'><strong>" +
      props.description +
      "</strong></span><span class='outcomes-value'>" +
      displayValue +
      "</span>"
  } else {
    newValue = displayValue
  }

  if (!_.isEmpty(props.value || !_.isNull(props.value))) {
    return (
      <div
        className="outcomes-values"
        dangerouslySetInnerHTML={{
          __html: newValue,
        }}
      />
    )
  } else {
    return null
  }
}

TypeRadioOutcomes.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  description: PropTypes.string,
}

export default TypeRadioOutcomes
